import { IStoreIntState } from '../state';
import { IUpdateConfigCableAction } from '../actions/cable-config/cable-config';

export type UpdateCableConfigAction = IUpdateConfigCableAction;

export const updateCableConfigReducer = (state: IStoreIntState,
    action: IUpdateConfigCableAction) => {
    const cableConfigurations = (action as IUpdateConfigCableAction).cableConfigurations;
    return ({
        ...state,
        cableConfigurations: {
            status:action.status,
            ...cableConfigurations}
    })
}